import i18n from '../plugins/vue-i18n'

const i18nService = {
    defaultLanguage: "uz",
    languages: [
        // {
        //   lang: "ru",
        //   name: i18n.t('lang.russian'),
        //   flag: "@/assets/images/ru.svg"
        // },
        {
            lang: "uz",
            name: i18n.t('lang.uzbekKrill'),
            flag: "@/assets/images/uz.svg"
        },
        {
            lang: "lt",
            name: i18n.t('lang.uzbekLatin'),
            flag: "@/assets/images/uz.svg"
        },
        {
            lang: "kr",
            name: i18n.t('lang.kr'),
            flag: "@/assets/images/uz.svg"
        },

    ],

    /**
     * Keep the active language in the localStorage
     * @param lang
     */
    setActiveLanguage(lang) {
        localStorage.setItem("language", lang);
    },

    /**
     * Get the current active language
     * @returns {string | string}
     */
    getActiveLanguage() {
        return localStorage.getItem("language") || this.defaultLanguage;
    }
};

export default i18nService;